var map = {
	"./de/Abb18-Bodenversiegelung-Kuehlung-Transp-Muc-Wzbg.png": 89318,
	"./en/Abb18-Bodenversiegelung-Kuehlung-Transp-Muc-Wzbg.png": 6425
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 74097;